const C = require("../constants");

const listCombo = data => {
    return {
        type: C.COMBO,
        data
    }
};

const removeCombo = data => {
    return {
        type: C.COMBO_REMOVE,
        data
    }
};

const addCombo = data => {
    return {
        type: C.COMBO_ADD,
        data
    }
};

export {
    listCombo,
    removeCombo,
    addCombo,
};


// WEBPACK FOOTER //
// ./src/actions/ComboActions.js